import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IntegracaoModel, IntegracaoPaginaModel } from '../model/integracao-model';
import { DisparoIntegracaoModel, DisparoIntegracaoPaginaModel } from '../model/disparo-automatico/disparo-integracao.model';

@Injectable({
  providedIn: 'root'
})
export class IntegracaoService {

  private readonly http = inject(HttpClient);

  private readonly urlBase = `${environment.urlBase}/integracoes`;

  buscarDoGrupo(pagina = 0, tamanho = 20, personalizada?: boolean): Observable<IntegracaoPaginaModel> {
    const params: Record<string, string | number | boolean> = { page: pagina, size: tamanho };
    if (personalizada != null) params['personalizada'] = personalizada;
    return this.http.get<IntegracaoPaginaModel>(this.urlBase, {
      params
    });
  }

  buscarParaDisparo(personalizada: boolean): Observable<DisparoIntegracaoPaginaModel> {
    return this.http.get<DisparoIntegracaoPaginaModel>(`${this.urlBase}/disparo`, {
      params: { page: 0, size: 100, personalizada }
    });
  }

  buscarIntegracaoParaDisparo(integracaoId: number): Observable<DisparoIntegracaoModel> {
    return this.http.get<DisparoIntegracaoModel>(`${this.urlBase}/disparo/${integracaoId}`);
  }

  salvar(integracao: IntegracaoModel): Observable<IntegracaoModel> {
    return this.http.post<IntegracaoModel>(this.urlBase, integracao);
  }

  inativar(integracaoId: number): Observable<void> {
    return this.http.delete<void>(`${this.urlBase}/${integracaoId}`);
  }
}
